var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.645c3.616 0 6.667.588 6.667 2.854 0 2.268-3.07 2.834-6.666 2.834-3.615 0-6.667-.587-6.667-2.854 0-2.267 3.071-2.834 6.667-2.834zm0-10.978a4.394 4.394 0 0 1 4.412 4.409 4.395 4.395 0 0 1-4.411 4.41 4.396 4.396 0 0 1-4.412-4.41 4.395 4.395 0 0 1 4.412-4.41z",
    fill: "#4CA1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2dfee200e8a1f0e0a0f0df0bb80e2772.svg";
export { ForwardRef as ReactComponent };